import { useTiptap } from "@tiptap/react";

import ToolbarInner from "./ToolbarInner";
import { ToolbarProps } from "./types";

const Toolbar = ({ isDisabled }: ToolbarProps) => {
    const { editor } = useTiptap();

    if (!editor) return null;

    return <ToolbarInner editor={editor} isDisabled={isDisabled} />;
};

export default Toolbar;
